<template>
  <div>
    <b-card style="background-color: rgb(255, 127, 96, 0.0); height: 1200px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px; ">
      <b-row class="mb-1">
        <b-col
          lg="4"
          md="4"
          sm="12"
        >
          <span
            style="font-size: 20px;"
          > วิเคราะห์เหตุการณ์ </span>
        </b-col>
        <b-col
          lg="8"
          md="8"
          sm="12"
          class="d-flex align-items-center justify-content-end"
        >
          <label style="padding-right:14px; font-size: 15px">ประเภท</label>
          <b-form-group style="padding-right:14px">
            <v-select
              v-model="searchImage.type_analytic"
              :reduce="(option) => option.key"
              :options="[
                { label: 'รถหยุด', key: 'carStop' },
                { label: 'รถย้อนศร', key: 'wrongWay' },
              ]"
              @input="getImage()"
            />
          </b-form-group>
          <label style="padding-right:14px; font-size: 15px">วันที่</label>
          <b-form-group style="padding-right:14px">
            <flat-pickr
              v-model="searchImage.dateFrom"
              class="form-control"
              @input="getImage()"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-for="(item, index) in img.slice(0,15)"
          :key="index"
          xl="4"
          lg="6"
          md="12"
          sm="12"
        >
          <b-card
            :img-src="img[index].FilePath"
            overlay
            text-variant="white"
            img-alt="card img"
            body-class="bg-overlay"
            @click="showImg(img[index].FilePath, img[index].TID)"
          >
            <b-card-title
              class="text-white"
              style="margin-top: -10px; font-size: 14px;"
            >
              เหตุการณ์เมื่อ: {{ img[index].DATE_TIME }}
            </b-card-title>
            <div class="card-footer text-center">
              <span class="d-flex justify-content-between align-items-center">
                สายทาง: {{ img[index].detail }}
              </span>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BFormGroup, BCardTitle,
} from 'bootstrap-vue'
import axios from '@axios'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormGroup,
    flatPickr,
    vSelect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      img: [],
      ISOnline: [],
      searchImage: {
        dateFrom: '',
        type_analytic: 'carStop',
        department: '',
      },
    }
  },
  mounted() {
    this.searchImage.department = this.userData.department
    this.setToday()
    this.getImage()
  },
  methods: {
    getImage() {
      axios
        .post('/imgAnalyticTotal', this.searchImage)
        .then(response => {
          this.img = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = (`0${p.getDate()}`).slice(-2)
      const year = p.getFullYear()
      this.searchImage.dateFrom = `${year}-${month}-${date}`
      // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    showImg(img, id) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        imageWidth: 800,
        imageHeight: 400,
        background: 'hsla(40%, 100%, 100%, 1)',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'ลบรูป',
        showCloseButton: true,
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal({
            title: '<span style="color:#000000">ต้องการลบข้อมูลหรือไม่?</span>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(async result1 => {
            if (result1.value) {
              try {
                const selectedID = id
                await axios.post('/deleteImgAnalytic', { type_analytic: this.searchImage.type_analytic, id: selectedID })
                this.$swal({
                  icon: 'success',
                  title: '<span style="color:#000000">ลบข้อมูลเรียบร้อย.</span>',
                  // text: 'Deleted successfully.',
                  showConfirmButton: false,
                  timer: 1000,
                })
                this.getImage()
              } catch (error) {
                this.$swal({
                  title: 'Error!',
                  text: 'Error',
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              }
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.card-footer:last-child {
    border-radius: 0!important;
}

.card-footer {
    padding: 0!important;
    background-color: unset!important;
    border-top: unset!important;
}

.text-center {
    color: #fff;
}

.card-img-overlay {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
</style>
